<template>
  <div class="row mt-4">
    <!-- Panel de filtro y resumen -->
    <div class="col-lg-6">
      <div class="card p-3">
        <h5 class="mb-3">Informe de Extrusión</h5>

        <!-- Filtros -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label for="fecha_inicio" class="form-label">Fecha inicio</label>
            <input
              id="fecha_inicio"
              type="date"
              class="form-control"
              v-model="fecha_inicio"
            />
          </div>
          <div class="col-md-6">
            <label for="fecha_fin" class="form-label">Fecha fin</label>
            <input
              id="fecha_fin"
              type="date"
              class="form-control"
              v-model="fecha_fin"
            />
          </div>
        </div>

        <!-- Gráfico -->
        <canvas id="extrusionChart"></canvas>

        <!-- Resumen -->
        <ul class="mt-3">
          <li>
            <strong>Total de Producciones:</strong> {{ resumen.total_registros }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Tabla Detallada -->
    <div class="col-lg-6">
      <div class="card p-3">
        <h5 class="mb-3">Detalle de Producción y Extrusión</h5>

        <div class="table-responsive">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Modelo</th>
                <th>Máquina</th>
                <th>Programado</th>
                <th>Perdido</th>
                <th>Efectivo</th>
                <th>Cant. Extr.</th>
                <th>Consumo Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in producciones" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.modelo || "—" }}</td>
                <td>{{ item.extrusion?.maquina || "—" }}</td>
                <td>{{ item.extrusion?.tiempo_programado || 0 }}</td>
                <td>{{ item.extrusion?.tiempo_perdido || 0 }}</td>
                <td>{{ item.extrusion?.tiempo_efectivo || 0 }}</td>
                <td>{{ item.extrusion?.cantidad_extruida || 0 }}</td>
                <td>{{ item.extrusion?.consumo_total || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default {
  name: "InformeExtrusion",
  data() {
    const hoy = new Date();
    const hace15 = new Date();
    hace15.setDate(hoy.getDate() - 15);

    const formatDate = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    return {
      fecha_inicio: formatDate(hace15),
      fecha_fin: formatDate(hoy),
      resumen: { total_registros: 0, rango: { desde: null, hasta: null } },
      producciones: [],
      totales: [],
      chartInstance: null,
    };
  },
  watch: {
    fecha_inicio() {
      this.fetchInforme();
    },
    fecha_fin() {
      this.fetchInforme();
    },
  },
  methods: {
    async fetchInforme() {
      try {
        const params = {
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
        };

        const res = await this.$store.dispatch("analitycs/getInformeExtrusion", params);
        const data = res.data;

        this.resumen = {
          total_registros: data.total_registros || 0,
          rango: data.rango || {},
        };
        this.producciones = data.producciones || [];
        this.totales = data.totales || [];

        this.renderChart();
      } catch (error) {
        console.error("Error cargando informe de extrusión:", error);
      }
    },

    renderChart() {
      if (this.chartInstance) this.chartInstance.destroy();

      const ctx = document.getElementById("extrusionChart");

      // Gráfico por modelo con totales
      const labels = this.totales.map((t) => t.modelo || `#${t.inventory_id}`);
      const dataExtrusion = this.totales.map((t) => t.total_extrusion);
      const dataPeso = this.totales.map((t) => t.total_peso_extruido);
      const dataConsumo = this.totales.map((t) => t.total_consumo);

      this.chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels,
          datasets: [
            { label: "Cantidad Extrudida", data: dataExtrusion, backgroundColor: "#36A2EB" },
            { label: "Peso Extruido", data: dataPeso, backgroundColor: "#FFCE56" },
            { label: "Consumo Total", data: dataConsumo, backgroundColor: "#FF6384" },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { position: "bottom" },
          },
          scales: {
            y: { beginAtZero: true },
          },
        },
      });
    },
  },
  mounted() {
    this.fetchInforme();
  },
};
</script>

<style scoped>
.table {
  font-size: 0.85rem;
}
</style>
